import {ImageOpContextImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-imgproc"
import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/output-node/definition"
import {ImageOpOutputHal} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/output-node/hal"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"

@registerNode
export class ImageOpNodeOutput extends BasicSpecializingImageOpNode<typeof definition, ImageOpOutputHal> {
    static nodeClass = "ImageOpNodeOutput"
    static definition = definition

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpOutputHal, parameters)
    }

    override toImgProc = async (evaluator: Evaluator<ImageOpContextImgProc>, parameters: ImageOpParametersOfType<typeof definition, "imgproc">) => {
        const {sourceImage} = await evaluator.getAll(parameters)
        return sourceImage
    }
}
